import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PER_PAGE_OPTIONS } from '../../utils/constants';

export default function Pagination({ page, totalPages, total, limit, onPageChange, onLimitChange }) {
  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 bg-white rounded-xl border border-gray-100 px-4 py-3 shadow-panel">
      <div className="text-sm text-gray-500">
        Showing <span className="font-medium text-gray-700">{Math.min((page - 1) * limit + 1, total)}</span>–<span className="font-medium text-gray-700">{Math.min(page * limit, total)}</span> of <span className="font-medium text-gray-700">{total.toLocaleString()}</span>
      </div>
      <div className="flex items-center gap-2">
        <select
          value={limit}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          className="border border-gray-200 rounded-lg px-2.5 py-1.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-ysrcp-500 transition-shadow"
        >
          {PER_PAGE_OPTIONS.map(n => <option key={n} value={n}>{n} / page</option>)}
        </select>
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          className="p-1.5 rounded-lg border border-gray-200 disabled:opacity-30 hover:bg-ysrcp-50 hover:border-ysrcp-200 hover:text-ysrcp-600 min-h-[44px] min-w-[44px] sm:min-h-0 sm:min-w-0 flex items-center justify-center transition-all"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <span className="text-sm px-3 py-1 hidden sm:inline bg-ysrcp-50 text-ysrcp-700 font-medium rounded-lg">
          {page} / {totalPages}
        </span>
        <span className="text-sm px-2 py-1 sm:hidden bg-ysrcp-50 text-ysrcp-700 font-medium rounded-lg">{page}/{totalPages}</span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          className="p-1.5 rounded-lg border border-gray-200 disabled:opacity-30 hover:bg-ysrcp-50 hover:border-ysrcp-200 hover:text-ysrcp-600 min-h-[44px] min-w-[44px] sm:min-h-0 sm:min-w-0 flex items-center justify-center transition-all"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
